import { render } from "./AboutUs.vue?vue&type=template&id=7b5ac99a&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=7b5ac99a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7b5ac99a"

export default script